//
//
//
//
//
//

import canonicalUrls from '~/mixins/canonicalUrls';

export default {
    mixins: [canonicalUrls],
    head() {
        return {
            link: this.head.link,
        };
    },
};
